(() => {
  'use strict';

  const DAY_NUMBERS = new Map([
    ['montag', 1],
    ['mo', 1],
    ['dienstag', 2],
    ['di', 2],
    ['mittwoch', 3],
    ['mi', 3],
    ['donnerstag', 4],
    ['do', 4],
    ['freitag', 5],
    ['fr', 5],
    ['samstag', 6],
    ['sa', 6],
    ['sonntag', 7],
    ['so', 7],
  ]);

  const DISPLAY_DAYS = [
    'Montag',
    'Dienstag',
    'Mittwoch',
    'Donnerstag',
    'Freitag',
    'Samstag',
    'Sonntag',
  ];

  /*
   * Leeres Metafeld = täglich produziert.
   * Versand findet trotzdem nur Montag bis Freitag statt.
   */
  const DEFAULT_DAYS = [1, 2, 3, 4, 5, 6];

  const FORECAST_SELECTOR =
    'production-shipping-forecast';

  class ProductionShippingForecast extends HTMLElement {
    connectedCallback() {
      window.clearInterval(this.updateTimer);

      this.scheduleRender();

      /*
       * Aktualisiert die Anzeige, falls eine Seite
       * während des Bestellschlusses geöffnet bleibt.
       */
      this.updateTimer = window.setInterval(() => {
        this.scheduleRender();
      }, 60_000);
    }

    disconnectedCallback() {
      window.clearInterval(this.updateTimer);
      window.cancelAnimationFrame(this.renderFrame);
    }

    scheduleRender() {
      window.cancelAnimationFrame(this.renderFrame);

      this.renderFrame = window.requestAnimationFrame(() => {
        this.renderForecast();
      });
    }

    getZonedNow(timeZone) {
      const formatter = new Intl.DateTimeFormat('de-DE', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      });

      const values = {};

      for (const part of formatter.formatToParts(new Date())) {
        if (part.type !== 'literal') {
          values[part.type] = part.value;
        }
      }

      return {
        year: Number(values.year),
        month: Number(values.month),
        day: Number(values.day),
        hour: Number(values.hour),
        minute: Number(values.minute),
      };
    }

    normalizeDays(values) {
      /*
       * Normalerweise liefert das Shopify-Listenmetafeld
       * bereits ein Array. Diese Ergänzung unterstützt
       * vorsichtshalber auch einen einzelnen Textwert.
       */
      if (typeof values === 'string') {
        values = values
          .split(/[,;|•]/)
          .map((value) => value.trim())
          .filter(Boolean);
      }

      if (!Array.isArray(values) || values.length === 0) {
        return DEFAULT_DAYS;
      }

      const normalized = values
        .map((value) => {
          const cleanedValue = String(value)
            .trim()
            .toLocaleLowerCase('de-DE');

          return DAY_NUMBERS.get(cleanedValue);
        })
        .filter(Boolean);

      return normalized.length
        ? [...new Set(normalized)]
        : DEFAULT_DAYS;
    }

getWeekStart(date) {
  const weekday = date.getUTCDay() || 7;

  const monday = new Date(date);

  monday.setUTCDate(
    date.getUTCDate() - (weekday - 1)
  );

  return monday;
}

getFirstShippingDateInWeek(days, weekStart, earliestAllowedDate) {
  // Versand ist ausschließlich Montag bis Freitag.
  for (let offset = 0; offset <= 4; offset += 1) {
    const candidate = new Date(weekStart);

    candidate.setUTCDate(
      weekStart.getUTCDate() + offset
    );

    // Dieser Produktionstag liegt bereits vor dem
    // Bestellzeitpunkt bzw. hinter dem 8-Uhr-Cutoff.
    if (candidate < earliestAllowedDate) {
      continue;
    }

    const weekday = candidate.getUTCDay() || 7;

    if (days.includes(weekday)) {
      return candidate;
    }
  }

  return null;
}

renderForecast() {
  const dataElement = this.querySelector(
    '[data-forecast-data]'
  );

  const dateElement = this.querySelector(
    '[data-forecast-date]'
  );

  if (!dataElement || !dateElement) {
    return;
  }

  let data;

  try {
    data = JSON.parse(dataElement.textContent);
  } catch (error) {
    console.error(
      'Versandprognose: ungültige Produktdaten.',
      error
    );

    dateElement.textContent = 'Termin wird bestätigt';
    return;
  }

  const timeZone =
    this.dataset.timeZone || 'Europe/Berlin';

  const cutoffMinutes =
    Number(this.dataset.cutoffMinutes) || 480;

  let now;

  try {
    now = this.getZonedNow(timeZone);
  } catch (error) {
    console.error(
      'Versandprognose: ungültige Zeitzone.',
      error
    );

    now = this.getZonedNow('Europe/Berlin');
  }

  const currentMinutes =
    now.hour * 60 + now.minute;

  // Ab 08:00 Uhr zählt der heutige Tag nicht mehr.
  const firstOffset =
    currentMinutes >= cutoffMinutes ? 1 : 0;

  const baseDate = new Date(
    Date.UTC(
      now.year,
      now.month - 1,
      now.day,
      12
    )
  );
  // Zentraler Wiederbeginn des Versands
  const resumeDateText =
    (this.dataset.resumeDate || '').trim();

  let resumeDate = null;

  if (resumeDateText) {
    const match =
      /^(\d{4})-(\d{2})-(\d{2})$/.exec(resumeDateText);

    if (match) {
      resumeDate = new Date(Date.UTC(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3]),
        12
      ));

      if (
        resumeDate.toISOString().slice(0, 10) !==
        resumeDateText
      ) {
        resumeDate = null;
      }
    }

    // Bei ungültigem Datum keine falsche Prognose anzeigen
    if (!resumeDate) {
      dateElement.textContent = 'Termin wird bestätigt';
      console.error('Ungültiges Versandstartdatum:', resumeDateText);
      return;
    }
  }
  const items = Array.isArray(data.items)
    ? data.items
    : [];

  if (items.length === 0) {
    dateElement.textContent = 'Termin wird bestätigt';
    return;
  }

  const normalizedItemDays = items.map((item) =>
    this.normalizeDays(item.days)
  );

  // Montag der aktuellen Kalenderwoche.
  const currentWeekStart =
    this.getWeekStart(baseDate);

  // Frühester noch erlaubter Produktionstag.
  const earliestCurrentDate =
    new Date(baseDate);

  earliestCurrentDate.setUTCDate(
    baseDate.getUTCDate() + firstOffset
  );

  let itemDates = null;

  /*
   * Suche die erste Kalenderwoche,
   * in der ALLE Produkte frisch produziert
   * und innerhalb derselben Woche versendet
   * werden können.
   */
  for (
    let weekOffset = 0;
    weekOffset <= 8;
    weekOffset += 1
  ) {
    const weekStart =
      new Date(currentWeekStart);

    weekStart.setUTCDate(
      currentWeekStart.getUTCDate() +
        weekOffset * 7
    );

    let earliestAllowedDate =
      weekOffset === 0
        ? earliestCurrentDate
        : weekStart;

    // Versandpause für jede Kalenderwoche beachten
    if (
      resumeDate &&
      resumeDate > earliestAllowedDate
    ) {
      earliestAllowedDate = resumeDate;
    }

    const datesForThisWeek =
      normalizedItemDays.map((days) =>
        this.getFirstShippingDateInWeek(
          days,
          weekStart,
          earliestAllowedDate
        )
      );

    const allProductsAvailable =
      datesForThisWeek.every(
        (date) => date !== null
      );

    if (allProductsAvailable) {
      itemDates = datesForThisWeek;
      break;
    }
  }

  if (!itemDates) {
    dateElement.textContent =
      'Termin wird bestätigt';
    return;
  }

  // Spätester Produktionstag dieser gemeinsamen Woche.
  const latestTimestamp = Math.max(
    ...itemDates.map(
      (date) => date.getTime()
    )
  );

  const forecastDate =
    new Date(latestTimestamp);

  dateElement.textContent =
    new Intl.DateTimeFormat('de-DE', {
      weekday: 'long',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(forecastDate);

  const daysElement = this.querySelector(
    '[data-production-days]'
  );

  if (daysElement) {
    const productDays =
      this.normalizeDays(
        items[0]?.days
      );

    // Sichtbare Versandtage:
    // nur Montag bis Freitag.
    daysElement.textContent =
      productDays
        .filter(
          (day) => day >= 1 && day <= 5
        )
        .map(
          (day) => DISPLAY_DAYS[day - 1]
        )
        .join(' · ');
  }
}

}

  if (!customElements.get(FORECAST_SELECTOR)) {
    customElements.define(
      FORECAST_SELECTOR,
      ProductionShippingForecast
    );
  }

  /*
   * Berechnet alle aktuell sichtbaren Prognosen neu.
   */
  function renderAllForecasts() {
    document
      .querySelectorAll(FORECAST_SELECTOR)
      .forEach((element) => {
        if (
          typeof element.scheduleRender === 'function'
        ) {
          element.scheduleRender();
        }
      });
  }

  /*
   * Horizon tauscht Warenkorb-Inhalte dynamisch aus.
   * Mehrere kurze Durchläufe fangen sowohl das Event
   * als auch den anschließenden DOM-Austausch ab.
   */
  function renderAfterCartUpdate() {
    renderAllForecasts();

    window.setTimeout(
      renderAllForecasts,
      100
    );

    window.setTimeout(
      renderAllForecasts,
      500
    );
  }

  function handleCartUpdate(event) {
    const eventPromise =
      event?.promise ||
      event?.detail?.promise;

    if (
      eventPromise &&
      typeof eventPromise.then === 'function'
    ) {
      Promise.resolve(eventPromise).then(
        renderAfterCartUpdate,
        renderAfterCartUpdate
      );

      return;
    }

    renderAfterCartUpdate();
  }

  function startGlobalListeners() {
    if (
      window.productionShippingForecastStarted
    ) {
      return;
    }

    window.productionShippingForecastStarted = true;

    /*
     * Aktuelles standardisiertes Shopify-Event.
     * Capture sorgt dafür, dass auch Events erkannt
     * werden, die auf einem Warenkorbelement starten.
     */
    document.addEventListener(
      'shopify:cart:lines-update',
      handleCartUpdate,
      true
    );

    /*
     * Horizon-kompatibles Warenkorb-Event.
     */
    document.addEventListener(
      'cart:update',
      handleCartUpdate,
      true
    );

    /*
     * Beim Öffnen des Warenkorbs nochmals berechnen.
     */
    document.addEventListener(
      'shopify:cart:view',
      renderAfterCartUpdate,
      true
    );

    /*
     * Zusätzliche Absicherung:
     * Erkennt, wenn Horizon den Warenkorb oder die
     * JSON-Produktdaten im Hintergrund austauscht.
     */
    const observer = new MutationObserver(
      (mutations) => {
        const forecastsToRender = new Set();

        for (const mutation of mutations) {
          const mutationTarget =
            mutation.target.nodeType ===
            Node.ELEMENT_NODE
              ? mutation.target
              : mutation.target.parentElement;

          const changedDataElement =
            mutationTarget?.closest?.(
              '[data-forecast-data]'
            );

          const changedForecast =
            changedDataElement?.closest?.(
              FORECAST_SELECTOR
            );

          if (changedForecast) {
            forecastsToRender.add(changedForecast);
          }

          for (const node of mutation.addedNodes) {
            if (
              node.nodeType !== Node.ELEMENT_NODE
            ) {
              continue;
            }

            if (node.matches(FORECAST_SELECTOR)) {
              forecastsToRender.add(node);
            }

            node
              .querySelectorAll?.(FORECAST_SELECTOR)
              .forEach((forecast) => {
                forecastsToRender.add(forecast);
              });

            if (
              node.matches('[data-forecast-data]')
            ) {
              const forecast =
                node.closest(FORECAST_SELECTOR);

              if (forecast) {
                forecastsToRender.add(forecast);
              }
            }

            node
              .querySelectorAll?.(
                '[data-forecast-data]'
              )
              .forEach((dataNode) => {
                const forecast =
                  dataNode.closest(
                    FORECAST_SELECTOR
                  );

                if (forecast) {
                  forecastsToRender.add(forecast);
                }
              });
          }
        }

        forecastsToRender.forEach((forecast) => {
          if (
            typeof forecast.scheduleRender ===
            'function'
          ) {
            forecast.scheduleRender();
          }
        });
      }
    );

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    renderAfterCartUpdate();
  }
/*
 * Zusätzliche Horizon-Absicherung:
 * Falls ein dynamisch eingesetzter Warenkorb bei
 * "Wird berechnet …" hängen bleibt, wird die Prognose
 * automatisch erneut angestoßen.
 */
/*
 * Sperrt oder entsperrt den normalen Checkout
 * und die Express-Checkout-Buttons.
 */
function setCartCheckoutLock(forecast, locked) {
  const cartComponent =
    forecast.closest('cart-items-component');

  if (!cartComponent) {
    return;
  }

  cartComponent.classList.toggle(
    'shipping-confirmation-locked',
    locked
  );

  const checkoutButton =
    cartComponent.querySelector(
      '#checkout, button[name="checkout"]'
    );

  if (checkoutButton) {
    /*
     * Wichtig:
     * Der Button wird NICHT mehr technisch deaktiviert.
     * Dadurch können Hover und Klick erkannt werden.
     */
    checkoutButton.setAttribute(
      'aria-disabled',
      locked ? 'true' : 'false'
    );

    /*
     * Event-Listener nur einmal pro Checkout-Button
     * registrieren.
     */
    if (
      checkoutButton.dataset
        .shippingConfirmationGuard !== 'true'
    ) {
      checkoutButton.dataset
        .shippingConfirmationGuard = 'true';

      /*
       * Tooltip einmal erzeugen.
       */
      const tooltip =
        document.createElement('div');

      tooltip.className =
        'production-shipping-forecast__checkout-tooltip';

      tooltip.textContent =
        'Bitte bestätige zuerst dein voraussichtliches Versanddatum.';

      document.body.appendChild(tooltip);

      const showTooltip = () => {
        const currentCartComponent =
          checkoutButton.closest(
            'cart-items-component'
          );

        if (
          !currentCartComponent ||
          !currentCartComponent.classList.contains(
            'shipping-confirmation-locked'
          )
        ) {
          return;
        }

        const currentForecast =
          currentCartComponent.querySelector(
            `${FORECAST_SELECTOR}[data-mode="cart"]`
          );

        const rect =
          checkoutButton.getBoundingClientRect();

        tooltip.style.left =
          `${rect.left + rect.width / 2}px`;

        tooltip.style.top =
          `${rect.top}px`;

        tooltip.classList.add('is-visible');

        currentForecast?.classList.add(
          'shipping-confirmation-hover'
        );
      };

      const hideTooltip = () => {
        tooltip.classList.remove('is-visible');

        const currentCartComponent =
          checkoutButton.closest(
            'cart-items-component'
          );

        const currentForecast =
          currentCartComponent?.querySelector(
            `${FORECAST_SELECTOR}[data-mode="cart"]`
          );

        currentForecast?.classList.remove(
          'shipping-confirmation-hover'
        );
      };

      checkoutButton.addEventListener(
        'mouseenter',
        showTooltip
      );

      checkoutButton.addEventListener(
        'mouseleave',
        hideTooltip
      );

      checkoutButton.addEventListener(
        'focus',
        showTooltip
      );

      checkoutButton.addEventListener(
        'blur',
        hideTooltip
      );

      /*
       * Klick auf gesperrten Checkout:
       * Checkout verhindern und dem Kunden zeigen,
       * was noch bestätigt werden muss.
       */
      checkoutButton.addEventListener(
        'click',
        (event) => {
          const currentCartComponent =
            checkoutButton.closest(
              'cart-items-component'
            );

          if (
            !currentCartComponent?.classList.contains(
              'shipping-confirmation-locked'
            )
          ) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          hideTooltip();

          const currentForecast =
            currentCartComponent.querySelector(
              `${FORECAST_SELECTOR}[data-mode="cart"]`
            );

          if (!currentForecast) {
            return;
          }

          currentForecast.classList.add(
            'shipping-confirmation-error'
          );

          const confirmation =
            currentForecast.querySelector(
              '[data-shipping-confirmation]'
            );

          const checkbox =
            currentForecast.querySelector(
              '[data-shipping-confirmation-checkbox]'
            );

          confirmation?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });

          window.setTimeout(() => {
            checkbox?.focus({
              preventScroll: true,
            });
          }, 300);
        },
        true
      );
    }
  }

  const expressButtons =
    cartComponent.querySelector(
      '.additional-checkout-buttons'
    );

  if (expressButtons) {
    expressButtons.setAttribute(
      'aria-disabled',
      locked ? 'true' : 'false'
    );

    if (locked) {
      expressButtons.setAttribute('inert', '');
    } else {
      expressButtons.removeAttribute('inert');
    }
  }
}

/*
 * Verbindet die Checkbox mit dem aktuell
 * berechneten Versanddatum.
 */
function syncCartConfirmation(forecast) {
  if (forecast.dataset.mode !== 'cart') {
    return;
  }

  const dateElement =
    forecast.querySelector(
      '[data-forecast-date]'
    );

  const confirmation =
    forecast.querySelector(
      '[data-shipping-confirmation]'
    );

  const checkbox =
    forecast.querySelector(
      '[data-shipping-confirmation-checkbox]'
    );

  const confirmationDate =
    forecast.querySelector(
      '[data-shipping-confirmation-date]'
    );

  if (
    !dateElement ||
    !confirmation ||
    !checkbox ||
    !confirmationDate
  ) {
    return;
  }

  const dateText =
    dateElement.textContent.trim();

  const dateIsReady =
    dateText &&
    !dateText.startsWith('Wird berechnet') &&
    !dateText.startsWith('Termin wird bestätigt');

  /*
   * Solange noch kein belastbares Datum existiert,
   * bleibt der Checkout gesperrt.
   */
  if (!dateIsReady) {
    confirmation.hidden = true;
    checkbox.checked = false;
    checkbox.dataset.forecastDate = '';

    setCartCheckoutLock(
      forecast,
      true
    );

    return;
  }

  confirmation.hidden = false;
  confirmationDate.textContent = dateText;

  /*
   * Ändert sich der Versandtag nach einer
   * Warenkorbänderung, muss erneut bestätigt werden.
   */
  if (
    checkbox.dataset.forecastDate !== dateText
  ) {
    checkbox.checked = false;
    checkbox.dataset.forecastDate = dateText;
  }

/*
 * Event nur einmal pro Checkbox registrieren.
 */
if (
  checkbox.dataset.shippingListener !== 'true'
) {
  checkbox.dataset.shippingListener = 'true';

checkbox.addEventListener('change', () => {
  setCartCheckoutLock(
    forecast,
    !checkbox.checked
  );

  if (checkbox.checked) {
    forecast.classList.remove(
      'shipping-confirmation-error'
    );

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          'Voraussichtlicher Versand':
            checkbox.dataset.forecastDate,
        },
      }),
    });
  }
});
}

  setCartCheckoutLock(
    forecast,
    !checkbox.checked
  );
}


/*
 * Alle aktuell vorhandenen Warenkorb-Prognosen
 * synchronisieren.
 */
function syncAllCartConfirmations() {
  document
    .querySelectorAll(FORECAST_SELECTOR)
    .forEach((forecast) => {
      syncCartConfirmation(forecast);
    });
}


/*
 * Zusätzliche Horizon-Absicherung:
 * - hängende Prognosen erneut anstoßen
 * - Checkout-Bestätigung synchron halten
 */
window.setInterval(() => {
  document
    .querySelectorAll(FORECAST_SELECTOR)
    .forEach((forecast) => {
      const dateElement =
        forecast.querySelector(
          '[data-forecast-date]'
        );

      if (
        dateElement &&
        dateElement.textContent
          .trim()
          .startsWith('Wird berechnet')
      ) {
        if (
          typeof forecast.scheduleRender ===
          'function'
        ) {
          forecast.scheduleRender();
        }
      }

      syncCartConfirmation(forecast);
    });
}, 500);
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startGlobalListeners,
      { once: true }
    );
  } else {
    startGlobalListeners();
  }
})();